import React, { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useRouter } from 'next/router';
import { withUserAgent } from 'next-useragent';
import Link from 'next/link';
import Store from '../../../store';
import SocketHandlers from './../../common/socket';
import Notifications from './../../common/notifications';
import DesktopChat from "../../common/desktopChatBox";
import { getLearnWorldUrl } from "../../../api/learn_worlds";
import { getUserNotifications, readAllNotifications } from "../../../store/actions/network";
import { getAllFriendsChat, setRegisterNotification } from "../../../store/actions/messages";
// import "./style.scss";
import MenuIcon from '../../common/Menu';

function AppHeader(props) {

	// //Starting // Need User Data....
	const { userAuth } = Store.getState();
	// userAuth.avatar = userAuth.avatar || `${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`;
	// 	//Ending // Need User Data....

	const node = useRef(), notifNode = useRef();
	const router = useRouter();
	const dispatch = useDispatch();
	const [showDropDown, setShowDropDown] = useState(false);
	const [showNotif, setShowNotif] = useState(false);
	const [showMsgs, setShowMsgs] = useState(false);
	const [showList, setShowList] = useState(false);
	const [href, setHref] = useState("");
	const [isDesktop, setIsDesktop] = useState(false);
	const [openMenu, setOpenMenu] = useState(false);
	const [LMSURL, setLMSURL] = useState(null);
	
	const signOut = () => {
		localStorage.clear();
		window.location.href = "/";
	}

	const toggleNav = () => {
		setShowDropDown(!showDropDown);
	}

	const { unreadNotifCount, unreadMsgCount, avatar, registerNotification } = useSelector((state) => ({
		unreadNotifCount: state.networkReducer.unreadNotifCount,
		unreadMsgCount: state.messagesReducer.unreadMsgCount,
		registerNotification: state.messagesReducer.registerNotification,
		avatar: state.userAuth.avatar,
	}), shallowEqual);

	const [profileImage, setProfileImage] = useState(`${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`);
	
	useEffect(() => {
		setHref(window.location.href);
		if (window.innerWidth > 767) {
			setIsDesktop(true);
		}
		document.addEventListener("mousedown", handleClick);
		document.addEventListener("mousedown", handleNotificationsClick);
		dispatch(getUserNotifications(userAuth));
		dispatch(getAllFriendsChat());
		if(!registerNotification) {
			dispatch(setRegisterNotification(true));
		}
		return () => {
			document.removeEventListener("mousedown", handleClick);
			document.removeEventListener("mousedown", handleNotificationsClick);
		};
	}, []);

	useEffect(() => {
		setProfileImage(avatar)
	}, [avatar]);

	useEffect(() => {
		if (LMSURL) {
			window.open(LMSURL);
		}
	}, [LMSURL]);

	const handleClick = e => {
		if (node?.current?.contains(e.target)) {
		} else {
			setShowDropDown(false);
		}
	};

	const handleNotificationsClick = e => {
		if (notifNode?.current?.contains(e.target)) {
		} else {
			setShowList(false);
			setShowMsgs(false);
			setShowNotif(false);
		}
	};
	
	const handleNotifications = val => {
		if (val == 'notif' && showList) {
			setShowMsgs(false);
			if(showNotif) {
				setShowNotif(false);
				setShowList(false);
			} else {
				setShowNotif(true);
				unreadNotifCount > 0 ? dispatch(readAllNotifications()) : '';
			}
		} else if (val == 'msgs' && showList){
			setShowNotif(false);
			if(showMsgs) {
				setShowMsgs(false);
				setShowList(false);
			} else {
				setShowMsgs(true);
			}
		} else if (!showList) {
			setShowList(true);
			if(val == 'notif') {
				setShowNotif(true);
				unreadNotifCount > 0 ? dispatch(readAllNotifications()) : '';
			} else {
				setShowMsgs(true);
			}
		} else {
			setShowList(false);
		}
	};

	const handleSubscription = (event) => {
		event.target.children[1].classList.remove('hidden');
		const redirectURL = "https://direct.bayanclaremont.org/account";

		if(props.ua.source !== 'BayanApp') var importantStuff = window.open('https://direct.bayanclaremont.org', '_blank');
		getLearnWorldUrl(redirectURL).then((res) => {
			// setLearnWorlds(res);
			if (res.success) {
				if(props.ua.source !== 'BayanApp') importantStuff.location.href = res.url;
				else window.location.href = res.url;
				// setLMSURL(res.url);
				event.target.children[1].classList.add('hidden');
				// window.localStorage.setItem("selected-course", data);
				// openIframe(res.url);
			}
		});
	}

	return (
		<div className="admin-header">
			{
				!registerNotification &&
				<SocketHandlers />
			}
			<div className="wrapper">
				<div className="inner-header desktop-header">
					<div className="area left-area">

						{/* menu header starts */}
						<div>
								<div className='menu'>
									<a onClick={() => setOpenMenu(true)}><img src={`${process.env.IMAGES_BASE_URL}/static-content/mb-menu.png.webp`} width="20" /></a>
								</div>
							<MenuIcon
								openMenu={openMenu}
								setOpenMenu={setOpenMenu}
							/>
						</div>
						{/* menu header ends */}
						<Link href="/home" as="/home">
							<a><img className="header-logo" src={`${process.env.IMAGES_BASE_URL}/static-content/bayanBigLogo.png.webp`} alt="bayan-logo" width="200" /></a>
							{/* <a><img src={`${process.env.IMAGES_BASE_URL}/static-content/bayanBigLogo.png.webp`} alt="bayan-logo" width="60" /></a> */}
						</Link>
						<div>
							{/* <form className="search-form">
								<a className="button postfix fa fa-search btn-search false"></a>
								<img src={`${process.env.IMAGES_BASE_URL}/static-content/search.png.webp`} alt="search"/>
								<input placeholder="Search Bayan" className="input-contral false"/>
							</form> */}
						</div>
					</div>
					<div className="area middle-area">
						<div className="links">
							<Link href="/home" as="/home">
								<a ><img src={(href.indexOf("home") > -1) ? `${process.env.IMAGES_BASE_URL}/static-content/home-icon.png.webp` : "/icons/home.png"} width="30" alt="home-icon" />
								Home</a>
							</Link>
						</div>
						<div className="links">
							<Link href="/home/network" as="/network">
								<a ><img src={(href.indexOf("network") > -1) ? "/icons/network-f.png" : `${process.env.IMAGES_BASE_URL}/static-content/network-icon.png.webp`} width="30" alt="network-icon" />
								{/* <a ><img src={`/icons/network-f.png`} width="30" alt="network-icon" /> */}
								My Network</a>
							</Link>
						</div>
						<div className="links">
							<Link href="/home/classes" as="/classes">
								<a ><img src={(href.indexOf("classes") > -1) ? "/icons/class-f.png" : `${process.env.IMAGES_BASE_URL}/static-content/clase-icon.png.webp`} width="30" alt="network-icon" />
								On-Demand	</a>
							</Link>
						</div>
						<div className={`links ${showDropDown ? 'open': ''}`}>
							<Link href="/home/profile" as="/profile"><span className="roundedimg"><img
								src={profileImage? profileImage:  `${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`}
								alt="user-image"
								className="user-image"
								width="40" /></span></Link>
							<Link href="/home/profile" as="/profile"><a >My Profile</a></Link>
							<div ref={node} className="down-arrow" onClick={() => toggleNav()}>
							<div>
									{showDropDown ? <div id="expand-profile" className="profile-dropdown">
												{/* <div><Link href="/home/billing" as="/billing"><a ><span><img src="/icons/bill.png" width="9" /></span> Billing</a></Link></div> */} 
												<div><Link href="/profile/edit" as="/profile/edit"><a ><span><img src="/icons/user.png" width="13" /></span>Edit Profile</a></Link></div>
										<div onClick={(e) => handleSubscription(e)}>
										<a  className="billing-btn"><span><img src="/icons/setting.png" width="13" /></span>Billing <img className="hidden" src={`/icons/loading.svg`} style={{ color: 'black', height: '25px', marginLeft: '10px' }} /></a></div>
												<div><Link href="/home/settings" as="/settings"><a ><span><img src="/icons/setting.png" width="12" /></span>Settings</a></Link></div>
												<div onClick={() => signOut()}><span><img src="/icons/logout.png" width="12" /></span> Sign Out</div>	
											</div> : <></>
										}
								</div>
						</div>
						</div>
					</div>
					<div className="area right-area" ref={notifNode}>
						<div className="notification" onClick={() => handleNotifications('notif')}>
							<img src={showNotif ? '/icons/notif-active.png' : `${process.env.IMAGES_BASE_URL}/static-content/bell-SIC.png.webp`} alt="bell SIC" />
								{
									unreadNotifCount > 0 &&
									<span className="circle">{unreadNotifCount}</span>
								}
						</div>
						<div className="msgs" onClick={() => handleNotifications('msgs')}>
							<img src={showMsgs ? '/icons/chat-active.png' : `${process.env.IMAGES_BASE_URL}/static-content/message-SIC.png.webp`} alt="bell SIC" />
							{
								unreadMsgCount > 0 &&
								<span className="circle">{unreadMsgCount}</span>
							}
						</div>
						{
							(showList) && <Notifications showNotif={showNotif} showMsgs={showMsgs} setShowList={setShowList} />
						}
					</div>
				</div>
			    {/* <div className="mobile-header">
					<a href="#"><img src={`${process.env.IMAGES_BASE_URL}/static-content/mb-menu.png.webp`} width="20"/></a>
					<a href="#"><img src={`${process.env.IMAGES_BASE_URL}/static-content/bayanBigLogo.png.webp`} width="120"/></a>
					<a href="#"><img src={`${process.env.IMAGES_BASE_URL}/static-content/mb-search.png.webp`}  width="20"/></a>
				</div> */}
			</div>
			{
				isDesktop &&
				<DesktopChat />
			}
		</div>
	);
}

export default withUserAgent(AppHeader);
